import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "switch-primary-language-modal" */'./SwitchPrimaryLanguageModal').then(mod => mod.default),
  LoadingComponent: () => null
});